<template>
  <div class="redirect" />
</template>

<script>
export default {
  name: 'Redirect',
  props: {
    routeName: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.$router.push({ name: this.routeName })
  }
}
</script>

<style scoped lang="scss">
.redirect {
  margin: 0;
  padding: 0;
  height: 0;
  width: 0;
}
</style>
